import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Signature } from '../models/signature';
import { View_signature } from '../models/view_signature';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class SignatureService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Signature> {
    return this.getWithRest("id/" + id);
  }

  getSignaturesForRoleOnEntry(entry_id: string, role: string): Promise<Signature[]> {
  	return this.getListWithRest('entry_id/' + entry_id + '/role/' + role);
  }

  getSignaturesForEntry(entry_id: string, load_people: boolean): Promise<Signature[]> {
    let rest_url: string = 'entry_id/' + entry_id;
    if(load_people){
      rest_url += "/people/true";
    }
    return this.getListWithRest(rest_url);
  }

private getListWithRest(rest_url: string) : Promise<Signature[]> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'signatures/' + rest_url).subscribe((response:any) => {
      if(response.type == 'signatures' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

private getWithRest(rest_url: string) : Promise<Signature> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'signatures/' + rest_url).subscribe((response:any) => {
      if(response.type == 'signature' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
}

public getViewSignatureById(id: string): Promise<View_signature> {
  return this.getViewSignatureWithRest('id/' + id);
}

private getViewSignatureWithRest(rest_url: string) : Promise<View_signature> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'view_signatures/' + rest_url).subscribe((response:any) => {
      if(response.type == 'view_signature' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
}

  create(signature: Signature): Promise<Signature> {
  	let post_data = {
        data: {
          type: 'signature',
          attributes: { signature: signature }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'signatures',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='signature') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }

  update_signature(signature: Signature): Promise<Signature> {
  	let put_data = {
        data: {
          type: 'signature',
          attributes: { signature: signature }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'signatures',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='signature') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }

  update_signatures(signatures: Signature[]): Promise<Signature[]> {
  	let put_data = {
        data: {
          type: 'signatures',
          attributes: { signatures: signatures }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'signatures',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='signatures') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }

    updateGuestSignature(signature: View_signature): Promise<any> {
    let put_data = {
        data: {
          type: 'guest_signature',
          attributes: { signature: signature }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'guest_signature',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='guest_signature_response') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }

}
